module.exports = __webpack_public_path__ + "static/media/img_profile_1.012a7a95.png";